// NOTE: NSAI-6755 / NSAI-7378 — the Toaster clamps every title to three lines.
// A toast whose message is a whole consequence or instruction (the SSO
// unverified-domain warning, the model-change warnings) passes this as its
// `classNames.title` to lift the clamp for that one toast rather than for the
// whole toaster.
export const TOAST_TITLE_UNCLAMPED_CLASS_NAME = "!line-clamp-none" as const;

// NOTE: The attribute sonner puts on its Toaster root. A dialog uses it to
// tell a click on a toast from a click outside the dialog.
export const SONNER_TOASTER_SELECTOR = "[data-sonner-toaster]" as const;

// NOTE: The toasts sonner actually shows. Toasts are click-through
// (pointer-events-none) apart from their buttons, so a click on a toast's
// text lands on whatever is underneath (a dialog's overlay); a dialog matches
// the pointer position against these toasts' boxes instead of the target.
// Toasts past `visibleToasts` (data-visible="false") keep a box above the
// stack at opacity 0, so they are left out: a click there is a click on the
// bare overlay. A toast animating out stays in: it is still on screen.
export const SONNER_VISIBLE_TOAST_SELECTOR =
  '[data-sonner-toast][data-visible="true"]' as const;
